export default __webpack_public_path__ + "4900bf65680709cb1913aba424da4e40.png";